import { useState } from 'react';
import { createTicket } from '../../store/actions/settingAction';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { TextWeight, isArabic } = dynamicfunction();
  const { clientDetails } = useSelector((state) => state.investments);
  const { helpContent } = useSelector((state) => state.content);
  const { settingLoading } = useSelector((state) => state.setting);

  const [image, setImage] = useState(null);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      helpContent?.web_help_contact?.data?.attributes,
      key,
      isArabic
    );
  };

  const onSubmit = (values, resetForm) => {
    const form_data = new FormData();

    form_data.append('ClientName', values?.name);
    form_data.append('ClientEmail', values?.email);
    form_data.append('ClientPhoneNumber', values?.phone);
    form_data.append('RequestTypeId', values?.request_type?.id);
    form_data.append('TicketSubject', values?.subject);
    form_data.append('TicketDescription', values?.description);
    if (image) form_data.append('Documents', image);

    dispatch(
      createTicket(form_data, () => {
        resetForm();
        setImage(null);
        navigate('/help/ticketing-history')
      })
    );
  };

  return {
    isArabic,
    TextWeight,
    settingLoading,
    getContentKey,
    onSubmit,
    image,
    setImage,
    navigate,
    clientDetails,
  };
};
